import { ChatInterface, FolderCollection, MessageInterface } from '@type/chat';
import { normalizeChats } from '@utils/chatNavigation';

import { StoreSlice } from './store';

export interface ChatSlice {
  messages: MessageInterface[];
  chats: ChatInterface[];
  currentChatIndex: number;
  generating: boolean;
  error: string | null;
  folders: FolderCollection;
  currentChatTokenCount: number;
  setMessages: (messages: MessageInterface[]) => void;
  setChats: (chats: ChatInterface[]) => void;
  setCurrentChatIndex: (index: number) => void;
  setGenerating: (generating: boolean) => void;
  setError: (error: string | null) => void;
  setFolders: (folders: FolderCollection) => void;
  setCurrentChatTokenCount: (tokenCount: number) => void;
}

export const createChatSlice: StoreSlice<ChatSlice> = (set) => ({
  folders: {},
  messages: [],
  chats: [], // ✅ Always initialize as empty array
  currentChatIndex: -1,
  generating: false,
  error: null,
  currentChatTokenCount: 0,
  setMessages: (messages: MessageInterface[]) => {
    set((prev: ChatSlice) => ({
      ...prev,
      messages,
    }));
  },
  setChats: (chats: ChatInterface[]) => {
  // Add validation in the store itself
  if (typeof chats === 'function') {
    console.error('🚨 STORE BUG: Received function instead of array!');
    console.trace();
    return; // Don't update state
  }

  if (!Array.isArray(chats)) {
    console.error('🚨 STORE BUG: Received non-array:', typeof chats);
    console.trace();
    return;
  }

    set((prev: ChatSlice) => ({
      ...prev,
      chats: normalizeChats(chats),
    }));
  },
  setCurrentChatIndex: (index: number) => {
    set((prev: ChatSlice) => ({
      ...prev,
      currentChatIndex: index,
    }));
  },
  setGenerating: (generating: boolean) => {
    set((prev: ChatSlice) => ({
      ...prev,
      generating,
    }));
  },
  setError: (error: string | null) => {
    set((prev: ChatSlice) => ({
      ...prev,
      error,
    }));
  },
  setFolders: (folders: FolderCollection) => {
    set((prev: ChatSlice) => ({
      ...prev,
      folders,
    }));
  },
  setCurrentChatTokenCount: (tokenCount: number) => {
    set((prev: ChatSlice) => ({
      ...prev,
      currentChatTokenCount: tokenCount,
    }));
  },
});
